<kig-loading></kig-loading>

<res-layout>
  <res-header *ngIf="!hideHeader">
    
    <res-logo *ngIf="uiEnvLabel != 'Stage'" [showAppName]="false" appName=”KIG” [routerLink]="'home'" style="margin-top: -9px; margin-left: -15px; padding: 0px; cursor: pointer; transform: scale(.8);">
      <img class="logo" res-logo src="assets/images/logo3c.png"/>
      <img class="logo" res-logo-horizontal src="assets/images/logo3c.png"/>
      <img class="logo" res-logo-vertical src="assets/images/logo3c.png"/>
    </res-logo>

    <res-logo *ngIf="uiEnvLabel == 'Stage'" [showAppName]="false" appName=”DOTS” [routerLink]="'home'" style="margin-top: -5px; margin-left: -25px; padding: 0px; cursor: pointer; transform: scale(.7);">
      <img class="logo" res-logo src="assets/images/dotsLogo.png"/>
      <img class="logo" res-logo-horizontal src="assets/images/dotsLogo.png"/>
      <img class="logo" res-logo-vertical src="assets/images/dotsLogo.png"/>
    </res-logo>

    <res-navigation>
      <label *ngIf="uiEnvLabel != 'Prod' && uiEnvLabel != 'Stage'" style="background-color: dodgerblue; color: white; font-size: 18px; margin-left: 0px; margin-top: 30px; padding-left: 5px; padding-right: 5px; border-radius: 4px">{{ uiEnvLabel }}</label>

      <res-navigation-item>
        <a [routerLinkActive]="'active'" [routerLink]="'dashboard'" href="#" class="resNavItem" resNavItem>Dashboards</a>
      </res-navigation-item>

      <res-navigation-item>
          <a [routerLinkActive]="'active'" resNavItem routerLink="/messages">Activity Log</a>
      </res-navigation-item>

      <res-navigation-group name="Configure">
        <res-navigation-item><a id="usersNav" href="#" routerLink="/users">Users</a></res-navigation-item>
        <res-navigation-item><a id="userGroupNav" href="#" routerLink="/usergroups">User Groups</a></res-navigation-item>
        <res-navigation-item><a id="devicesNav" href="#" routerLink="/register">Gateways</a></res-navigation-item>
        <res-navigation-item><a id="sensorsNav" href="#" routerLink="/sensors">Sensors</a></res-navigation-item>
        <res-navigation-item><a id="sensorGroupNav" href="#" routerLink="/sensorgroups">Sensor Groups</a></res-navigation-item>
        <res-navigation-item><a id="EventActionNav" href="#" routerLink="/events">Events & Actions</a></res-navigation-item>
        <res-navigation-item><a id="actionQueuesNav" href="#" routerLink="/actionqueues">Action Queues</a></res-navigation-item>
        <res-navigation-item><a id="importNav" href="#" routerLink="/import">Imports & Syncs</a></res-navigation-item>
      </res-navigation-group>

      <res-navigation-group name="READINGS & MAPS">
        <res-navigation-item><a id="ChartNav" href="#" routerLink="/chartreadings">Chart Group Readings</a></res-navigation-item>
        <res-navigation-item><a id="MapNav" href="#" routerLink="/mapreadings">GeoMap Readings</a></res-navigation-item>
        <!-- <res-navigation-item><a id="sensorsNav" href="#" routerLink="/sensors">Sensors & Readings</a></res-navigation-item> -->
        <res-navigation-item><a id="readingsNav" href="#" routerLink="/sensorreadings">Analyze Sensor Readings</a></res-navigation-item>
      </res-navigation-group>

      <!-- <res-navigation-item>
        <a [routerLinkActive]="'active'" resNavItem routerLink="/sensorreadings">Search Sensor Readings</a>
      </res-navigation-item> -->

      <res-navigation-item>
        <a [routerLinkActive]="'active'" resNavItem routerLink="/scoutview">Scoutview</a>
      </res-navigation-item>

    </res-navigation>

    <button class="theme-toggle" (click)="toggleTheme()" title="Toggle dark/light mode">
      <span class="theme-icon">{{ currentTheme === 'dark' ? '☀️' : '🌙' }}</span>
    </button>
  </res-header>

  <router-outlet></router-outlet>

  <res-footer>
    <div res-footer-content>
    </div>
    <div res-footer-application-details>
      <ul>
        <!-- <li>Developed by Team KIG</li> -->
        <li>Version {{versionInfo.version}}</li>
      </ul>
    </div>
  </res-footer>
</res-layout>

<p-blockUI [blocked]="uiBlocked$ | async" [baseZIndex]="1000">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>
<p-toast></p-toast>
